import PropTypes from 'prop-types';
import Modal from 'components/Modal';

const VerificationLoaderModal = ({ literals }) => (
  <Modal
    className='digital-loan-verification-loader-modal'
    position='center'
    animation='fade-enter'
    closeOnBackgroundClick={false}
    showCloseButton={false}
    onClose={() => {}}
  >
    <div className='digital-loan-verification-loader'>
      <h2 className='digital-loan-verification-loader__title'>{literals.title}</h2>
      <div className='digital-loan-verification-loader__content'>
        <span className='digital-loan-verification-loader__spinner' aria-hidden='true' />
        <span className='digital-loan-verification-loader__text'>{literals.verifying}</span>
      </div>
    </div>
  </Modal>
);

VerificationLoaderModal.propTypes = {
  literals: PropTypes.object.isRequired,
};

export default VerificationLoaderModal;
